import Modal from "../../UIelements/Modal";
import { useIntl } from 'react-intl';
import { FormEvent, useCallback, useRef, useState } from "react";
import * as Styled from './styles';
import Loading from "../../Loading";
import PrimaryButton from "../../FormElements/PrimaryButton";
import InputForwardRef, { InputForwardType } from "../../FormElements/InputForwardRef";
import { VALIDATOR_REQUIRE } from "../../../utils/validators";
import { updateSerialNumbers } from "../../../services";
import { toast } from 'react-toastify';
import { InputsType } from "../../../hooks/form-hook-typing";
import { useForm } from "../../../hooks/form-hook";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

enum InputSN {
  SERIAL_NUMBER = 'serialNumber',
};

const initialValue = {
  value: '',
  isValid: false,
};

const initialSNInputs: InputsType = {
  [InputSN.SERIAL_NUMBER]: initialValue,
};

type ModalProps = {
  onCancel: () => void;
  refresh: () => void;
  selectSerialNumber: number
  serialNumbers: any
};

const getSubmitUserData = (
  inputs: InputsType,
): any => ({
  serialNumber: inputs[InputSN.SERIAL_NUMBER].value
});

const ModalEditSerialNumber = (props: ModalProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const globalUser = useSelector((state: RootState) => state.user.object);
  const [formUserState, inputSNHandler] = useForm(
    initialSNInputs,
    false
  );

  const serialNumberRef = useRef<InputForwardType>(null);

  const touchAllUserFields = () => {
    if (serialNumberRef && serialNumberRef.current) serialNumberRef.current.touchHandler();
  };

  const handleUpdateSerialNumber = useCallback(
    async (): Promise<boolean> => {
      const data = getSubmitUserData(
        formUserState.inputs
      );
      try {
        await updateSerialNumbers(props.selectSerialNumber, data, globalUser?.user.accessToken ?? '')
          .then(resp => {
            toast.success(
              intl.formatMessage({
                id: 'company.Número de série editado com sucesso!',
              }).toUpperCase()
            );
            setIsLoading(false)
          })
          .catch(error => {
            console.log(error)
            toast.error(
              intl.formatMessage({
                id: 'company.Não foi possível editar o número de série. Tente novamente mais tarde',
              }).toUpperCase()
            );
          })
        return true;
      } catch (error) {
        toast.error(
          intl.formatMessage({
            id: 'company.Não foi possível editar o número de série. Tente novamente mais tarde',
          }).toUpperCase()
        );
        return false;
      }
    },
    [props, formUserState.inputs]
  );

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      setIsLoading(true);
      event.preventDefault();
      touchAllUserFields();
      if (!formUserState.isValid) {
        setIsLoading(false);
        return;
      }
      const isSuccess = await handleUpdateSerialNumber();
      setIsLoading(false);
      if (!isSuccess) return;
      props.onCancel();
      props.refresh();
    },
    [
      formUserState.isValid,
      handleUpdateSerialNumber,
      props
    ]
  );

  const loading = <Loading />;

  const footer = (
    <>
      <PrimaryButton
        type='submit'
        size='buttonModal'
        model='confirmation-gradient-modal'
        width='108px'
      >
        {intl.formatMessage({ id: 'store.salvar' })}
      </PrimaryButton>
      <PrimaryButton
        type='button'
        size='buttonModal'
        model='cancellation'
        width='108px'
        onClick={props.onCancel}
      >
        {intl.formatMessage({ id: 'menus.CANCELAR' })}
      </PrimaryButton>
    </>
  );

  const content = (
    <Styled.Container>
      <Styled.Row>
        <Styled.Content flexGrow={1}>
          <InputForwardRef
            id={InputSN.SERIAL_NUMBER}
            ref={serialNumberRef}
            type='text'
            label={intl.formatMessage({ id: 'company.Número de série' }) + ' *'}
            initialValid={true}
            initialValue={props.serialNumbers.serialNumber}
            validators={[VALIDATOR_REQUIRE()]}
            error3={Boolean(!(/^[A-Za-z0-9]+$/.test(formUserState.inputs[InputSN.SERIAL_NUMBER].value)) && formUserState.inputs[InputSN.SERIAL_NUMBER].value.length)}
            placeholder={intl.formatMessage({ id: 'company.Informe o número de série' })}
            errorText={intl.formatMessage({
              id: 'company.Preencha um número de série',
            })}
            errorText3={intl.formatMessage({
              id: `company.Preencha o número de série sem caracteres especiais`
            })}
            onInput={inputSNHandler}
          />
        </Styled.Content>
      </Styled.Row>
    </Styled.Container>
  );

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: 'company.EDITAR EQUIPAMENTO' })}
        width='500px'
        children={isLoading ? loading : content}
        footer={footer}
        onCancel={props.onCancel}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default ModalEditSerialNumber;